import { connect } from "react-redux";
import Loader from "./Loader";

const mapStateToProps = (store) => {
    return {
        loader: store.loader,
    };
};

export default connect(mapStateToProps)(Loader);
